<template>
  <div class="w-full">
    <div v-if="!errorPage">
      <div class="px-3 mt-5">
        <div class="flex justify-between items-center mb-4">
          <h1 class="font-[800] font-extrabold mt-3 uppercase mb-1">
            Performance Agreements
          </h1>
          <span
            v-if="!isEditable"
            class="cursor-pointer text-flame text-base font-semibold flex items-center gap-2"
            @click="handleEditPreference"
          >
            <Icon
              icon-name="icon-edit"
              size="xs"
              class="cursor-pointer inline-block"
            />
            <span>Edit Preference</span>
          </span>
          <span
            v-else
            class="cursor-pointer text-flame text-base font-semibold flex items-center gap-2"
            @click="handleCancelEdit"
          >
            <Icon
              icon-name="x"
              size="xs"
              class="cursor-pointer inline-block"
            />
            <span>Cancel Edit</span>
          </span>
        </div>
        <p>Select everyone who should be involved in an employee's performance evaluation.</p>

        <hr class="my-6"/>

        <div class="!mt-[24px]">
          <p>Employees can share agreement with</p>
          <div class="mt-3">
            <div class="flex w-full mb-3 gap-5 items-center">
              <checkbox
                label="Select All"
                value="1"
                label-style="color:#333333"
                checkbox-size="height:16px; width:16px; margin-top: 1px"
                v-model="settingsPayload.managerCanEditAgreement"
                :disabled="!isEditable"
                :class="{ 'opacity-50': !isEditable }"
              />
              <checkbox
                label="Direct Line Manager"
                label-style="color:#333333"
                checkbox-size="height:16px; width:16px; margin-top: 1px;"
                v-model="settingsPayload.managerCanLockAgreement"
                disabled
                :class="{ 'opacity-50': !isEditable }"
              />
              <checkbox
                label="Dotted Line Manager"
                label-style="color:#333333"
                checkbox-size="height:16px; width:16px; margin-top: 1px;"
                v-model="settingsPayload.dottedLineManagerCanShareAgreement"
                :disabled="!isEditable"
                :class="{ 'opacity-50': !isEditable }"
              />
              <!-- <checkbox
                label="2nd Level Manager"
                label-style="color:#333333"
                checkbox-size="height:16px; width:16px; margin-top: 1px;"
                v-model="settingsPayload.secondLevelManager"
                disabled
              /> -->
              <checkbox
                label="HR"
                label-style="color:#333333"
                checkbox-size="height:16px; width:16px; margin-top: 1px;"
                v-model="settingsPayload.hrcanshareagreement"
                disabled
                :class="{ 'opacity-50': !isEditable }"
              />
            </div>
          </div>
        </div>

        <hr class="my-6"/>

        <div class="" v-if="!HideReminderOnProduction">
          <h4 class="text-darkPurple text-base font-bold px-2">
            Automatically send reminders to employees who have not submitted
            performance agreements.
          </h4>

          <div class="mt-5">
            <div class="flex w-full">
              <div class="flex flex-col">
                <checkbox
                  label="Yes, send reminders"
                  class="w-60"
                  value="1"
                  label-style="color:#333333"
                  checkbox-size="height:16px; width:16px;"
                  v-model="settingsPayload.sendReminders"
                  :disabled="!isEditable"
                  :class="{ 'opacity-50': !isEditable }"
                />
                <div
                  class="flex ml-3"
                  style="border-left: 1px dashed #878e99"
                  v-if="settingsPayload.sendReminders"
                >
                  <c-select
                    placeholder="Select"
                    variant="w-full capitalize"
                    class="w-40 ml-4"
                    :options="reminderOptions"
                    v-model="selectReminder"
                    :disabled="!isEditable"
                    :class="{ 'opacity-50': !isEditable }"
                  />
                </div>
              </div>
              <div class="-ml-4 mt-1" v-if="settingsPayload.sendReminders">
                <label>Message</label>
                <CTextarea
                  placeholder="--Custom Message--"
                  variant="primary w-1/2"
                  label="Message"
                  style="width: 100%; margin-top:5px;border-radius:8px;"
                  value=""
                  :row="10"
                  :height="40"
                  :input="null"
                  v-model="settingsPayload.reminderMessage"
                  :disabled="!isEditable"
                  :class="{ 'opacity-50': !isEditable }"
                />
              </div>
            </div>
          </div>
        </div>

        <hr class="my-6"/>

        <h1 class="font-[800] font-extrabold mt-3 uppercase">
          Performance Appraisal
        </h1>
        <p>Select who should be involved in an employee's performance evaluation.</p>

        <hr class="mt-6"/>

        <div class="">
          <div class="mt-5">
            <div class="flex flex-wrap justify-start gap-4 w-full items-center">
              <checkbox
                label="Select All"
                value="1"
                label-style="color:#333333"
                checkbox-size="height:16px; width:16px; margin:1px 7px 8px 1px;"
                v-model="isSelectedAll"
                @change="handleSelectAllAppraisers"
                :disabled="!isEditable"
                :class="{ 'opacity-50': !isEditable }"
              />
              <checkbox
                label="Direct Line Managers"
                class=""
                value="1"
                label-style="color:#333333"
                :disabled="true"
                checkbox-size="height:16px; width:16px; margin:1px 7px 8px 1px;"
                v-model="isDirectLineManagerSelected"
                :class="{ 'opacity-50': !isEditable }"
              />
              <checkbox
                label="Dotted line managers"
                value="1"
                label-style="color:#333333"
                checkbox-size="height:16px; width:16px; margin:1px 7px 8px 1px;"
                v-model="isDottedLineManagerSelected"
                @change="updateSelectedAppraisalReviewer('dotted_line_managers', $event)"
                :class="{ 'opacity-50': !isEditable }"
                :disabled="!isEditable"
              />
              <checkbox
                label="HR"
                value="1"
                :disabled="true"
                label-style="color:#333333"
                checkbox-size="height:16px; width:16px; margin:1px 7px 8px 1px;"
                v-model="isHrSelected"
                :class="{ 'opacity-50': !isEditable }"
              />
            </div>

            <div class="warning mt-5 border border-[#E993235C] bg-[#E9932314]">
              <Icon icon-name="warning" size="xs" class=" mr-2" style="fill: transparent;"/>
              <p>Note: Only employee's direct line manager can approve appraisal scores. The approved appraisal score becomes the average of both the direct line manager, level 2 manager and any other appraiser assigned to them. The final appraisal score is calculated as an average of all selected appraisers.</p>
            </div>
          </div>
        </div>
        <hr class="my-7"/>

        <div class="flex flex-row justify-end items-center gap-3" v-if="isEditable">
          <Button
            class="bg-dynamicBackBtn text-white buttons"
            :disabled="loading || !isEditable"
            @click="submitHandler"
          >
            Save
          </Button>

          <Button
            class="cancel-button inline-block text-[#321C3B] rounded-md"
            :disabled="loading"
            @click="handleCancel"
          >
            Cancel
          </Button>
        </div>
      </div>
    </div>

    <div v-else>
      <ErrorPage />
    </div>
  </div>
</template>

<script>
import Checkbox from "@scelloo/cloudenly-ui/src/components/checkbox";
import CSelect from "@scelloo/cloudenly-ui/src/components/select";
import CTextarea from "@scelloo/cloudenly-ui/src/components/text-area";
import ErrorPage from "@/modules/Admin/error403";
import Button from '@/components/Button';
import Icon from "@/components/Icon";

export default {
  components: {
    Checkbox,
    CSelect,
    CTextarea,
    ErrorPage,
    Button,
    Icon,
  },
  name: "GeneralSettings",
  data() {
    return {
      loading: false,
      isEditable: false,
      selectAllAppraisers: false,
      HideReminderOnProduction: process.env.NODE_ENV === "production",
      reminderOptions: [
        {
          id: 1,
          name: "weekly",
        },
        {
          id: 2,
          name: "monthly",
        },
      ],
      selectReminder: null,
      settingsPayload: {
        orgId: null,
        settingId: null,
        editDocument: "",
        managerCanEditAgreement: false,
        managerCanLockAgreement: true,
        lockSubmittedAgreement: false,
        sendReminders: true,
        frequency: "",
        reminderMessage: "",
        employeeInAppraisalProcess: false,
        lineManagerInAppraisalProcess: true,
        dottedLineManagerInAppraisalProcess: false,
        secondLevelManagerInAppraisal: false,
        othersInAppraisalProcess: false,
        hrInAppraisalProcess: true,
        appraisailScoringPreference: "",
        managerCanEditEmployeeAppraisal: false,
        managerCanLockAppraisalForEditing: false,
        lockSubmittedAppraisal: false,
        allowModeratorsSeeScore: false,
        permittedToEditPIP: "admin",
        hrcanshareagreement: true,
        dottedLineManagerCanShareAgreement: false,
        secondLevelManager: false,
        appraisalReviewer: ["hr","direct_line_managers"]
      },
      errorPage: false,
    };
  },
  computed: {
    isDirectLineManagerSelected: {
      get() {
        return this.settingsPayload.appraisalReviewer.includes('direct_line_managers');
      },
      set() {
      }
    },
    isDottedLineManagerSelected: {
      get() {
        return this.settingsPayload.appraisalReviewer.includes('dotted_line_managers');
      },
      set(value) {
        this.updateSelectedAppraisalReviewer('dotted_line_managers', value);
      }
    },
    isSecondLevelManagerSelected: {
      get() {
        return this.settingsPayload.appraisalReviewer.includes('second_level_manager');
      },
      set(value) {
        this.updateSelectedAppraisalReviewer('second_level_manager', value);
      }
    },
    isOthersSelected: {
      get() {
        return this.settingsPayload.appraisalReviewer.includes('others');
      },
      set(value) {
        this.updateSelectedAppraisalReviewer('others', value);
      }
    },
    isSelectedAll: {
      get() {
        return this.settingsPayload.appraisalReviewer.includes('select_all');
      },
      set(value) {
        this.updateSelectedAppraisalReviewer('select_all', value);
      }
    },
    isHrSelected: {
      get() {
        return this.settingsPayload.appraisalReviewer.includes('hr');
      },
      set() {
      }
    }
  },
  watch: {
    selectReminder(value) {
      const selectedOption = this.reminderOptions.find((option) => option.id === Number(value));
      if (selectedOption) {
        this.settingsPayload.frequency = selectedOption.name;
      }
    },
  },

  methods: {
    updateSelectedAppraisalReviewer(reviewerType, isSelected) {
      if (isSelected) {
        if (!this.settingsPayload.appraisalReviewer.includes(reviewerType)) {
          this.settingsPayload.appraisalReviewer.push(reviewerType);
        }
      } else {
        const index = this.settingsPayload.appraisalReviewer.indexOf(reviewerType);
        if (index > -1) {
          this.settingsPayload.appraisalReviewer.splice(index, 1);
        }
      }
    },

    handleSelectAllAppraisers(value) {
      if (value) {
        this.updateSelectedAppraisalReviewer('dotted_line_managers', true);
        this.updateSelectedAppraisalReviewer('second_level_manager', true);
        this.updateSelectedAppraisalReviewer('others', true);
      } else {
        this.settingsPayload.appraisalReviewer = this.settingsPayload.appraisalReviewer.filter(
          reviewer => ['hr', 'direct_line_managers'].includes(reviewer)
        );
      }
    },

    handleAppraisalReviewerChange(selectedItems) {
      this.settingsPayload.appraisalReviewer = selectedItems;
    },

    handleCancel() {
      if (this.isEditable) {
        this.handleCancelEdit();
      } else {
        this.$router.go(-1);
      }
    },

    async handleEditPreference() {
      try {
        await this.$handlePrivilege(
          "performance",
          "editPreference"
        );
        this.isEditable = true;
      } catch (error) {
        this.$toasted.error("You do not have permission to perform this task", {
          duration: 5000,
        });
      }
    },

    handleCancelEdit() {
      this.isEditable = false;
      // Reload the settings to revert any changes
      this.getGeneralSetting();
    },

    async submitHandler() {
      try {
        this.loading = true;
        await this.$handlePrivilege(
          "performance",
          "updatePerformanceGeneralSetting"
        );
        this.handleSubmit();
      } catch (error) {
        this.$toasted.error("You do not have permission to perform this task", {
          duration: 5000,
        });
      } finally {
        this.loading = false;
      }
    },

    handleSubmit() {
      this.settingsPayload.orgId = this.$orgId;
      const apiPayload = {
        ...this.settingsPayload,
        selectedAppraisalReviewer: this.settingsPayload.appraisalReviewer
      };

      this.$_createPerfomanceSetting(apiPayload)
        .then((response) => {
          this.$toasted.success(response.data.message, { duration: 5000 });
          this.isEditable = false;
        })
        .catch((error) => {
          this.$toasted.error(error.response.data.message, { duration: 5000 });
        });
    },

    getGeneralSetting() {
      this.$_getPerformanceGeneralSetting().then((response) => {
        const setting = response.data.PerformanceSettings[0];
        this.settingsPayload.settingId = setting.id;
        this.settingsPayload.orgId = setting.orgId;
        this.settingsPayload.editDocument = setting.editDocument;
        this.settingsPayload.dottedLineManagerCanShareAgreement = setting.dottedLineManagerCanShareAgreement;
                if (setting.appraisalReviewer && Array.isArray(setting.appraisalReviewer)) {
          this.settingsPayload.appraisalReviewer = setting.appraisalReviewer;
        } else {
          this.settingsPayload.appraisalReviewer = [];
          this.settingsPayload.appraisalReviewer.push('hr', 'direct_line_managers');
          if (setting.dottedLineManagerInAppraisalProcess) {
            this.settingsPayload.appraisalReviewer.push('dotted_line_managers');
          }
          if (setting.secondLevelManagerInAppraisal) {
            this.settingsPayload.appraisalReviewer.push('second_level_manager');
          }
          if (setting.othersInAppraisalProcess) {
            this.settingsPayload.appraisalReviewer.push('others');
          }
        }

        this.settingsPayload.appraisailScoringPreference =
          setting.appraisailScoringPreference;
        this.settingsPayload.managerCanEditEmployeeAppraisal =
          setting.managerCanEditEmployeeAppraisal;
        this.settingsPayload.managerCanLockAppraisalForEditing =
          setting.managerCanLockAppraisalForEditing;
        this.settingsPayload.lockSubmittedAppraisal =
          setting.lockSubmittedAppraisal;
        this.settingsPayload.allowModeratorsSeeScore =
          setting.allowModeratorsSeeScore;
        this.settingsPayload.permittedToEditPIP = setting.permittedToEditPIP;
        this.settingsPayload.managerCanEditAgreement =
          setting.managerCanEditAgreement;
        this.settingsPayload.managerCanLockAgreement =
          setting.managerCanLockAgreement;
        this.settingsPayload.lockSubmittedAgreement =
          setting.lockSubmittedAgreement;
        this.settingsPayload.sendReminders = setting.sendReminders;
        this.settingsPayload.reminderMessage = setting.reminderMessage;
        this.settingsPayload.employeeInAppraisalProcess =
          setting.employeeInAppraisalProcess;
        this.settingsPayload.lineManagerInAppraisalProcess =
          setting.lineManagerInAppraisalProcess;
        const frequencyOption = this.reminderOptions.find((option) => option.name === setting.frequency);
        if (frequencyOption) {
          this.selectReminder = frequencyOption.id;
        }

        return {};
      });
    },
  },

  async mounted() {
    try {
      await this.$handlePrivilege(
        "performance",
        "viewPreferencePage"
      );
      this.getGeneralSetting();
    } catch (error) {
      this.errorPage = true;
    }
  },
};
</script>

<style scoped>
.warning {
  display: flex;
  align-items: center;
  letter-spacing: 0.5px;
  background-color: #E9932314;
  padding: 10px;
  border-radius: 8px;
  font-size: 12px;
  color: #333333;
  border: 1px solid #E993235C;
  margin-bottom: 20px;
}

::v-deep .cloudenly-input-container {
  border-radius: 8px;
}
</style>
